import React from 'react';

/**
 * Props for {@link LabeledDateTimeRow}.
 */
interface LabeledDateTimeRowProps {
  /** Row label shown on the left (e.g. 'Time Declared'). */
  label: string;
  /** Pre-formatted date string; renders an em dash when empty. */
  date: string;
  /** Pre-formatted Zulu time string; renders an em dash when empty. */
  time: string;
}

/**
 * A read-only field row that displays a date and a Zulu time in two adjacent
 * inputs. Shared by the Audit modal's Time Declared, Previous Flight, and Next
 * Flight rows so all date/time values render in the same shape.
 */
const LabeledDateTimeRow: React.FC<LabeledDateTimeRowProps> = ({ label, date, time }) => (
  <div className="field-row">
    <label className="field-label">{label}</label>
    <div className="field-group">
      <div className="field-input-block">
        <span className="field-input-label">Date</span>
        <input type="text" value={date || '—'} readOnly className="field-input" />
      </div>
      <div className="field-input-block">
        <span className="field-input-label">Time (Z)</span>
        <input type="text" value={time || '—'} readOnly className="field-input" />
      </div>
    </div>
  </div>
);

export default LabeledDateTimeRow;
